export interface Project {
    title: string;
    date: Date;
    slug: string;
}

export const projects: Project[] = [
    {
        title: "Sample Project 1",
        date: new Date("2024-08-24"),
        slug: "sample-project-1",
    },
    {
        title: "Sample Project 2",
        date: new Date("2024-10-15"),
        slug: "sample-project-2",
    },
    {
        title: "Sample Project 3",
        date: new Date("2024-11-29"),
        slug: "sample-project-3",
    },
];
